import EmeraldCityMap from "@components/leafletMap/EmeraldCityMap";
import Button from "@components/common/Button.component";

function EmeraldCityMapLeaflet() {
  return (
    <div className="emeraldcity-leaflet-container">
      <div className="emeraldcity-leaflet-wrapper">
        <EmeraldCityMap />
      </div>
      {/* <Button className="emeraldcity-leaflet-btn" disabled>Explore The City</Button> */}
    </div>
  );
}

export default EmeraldCityMapLeaflet;
